import React from "react";
import PropTypes from "prop-types";

import Modal from "components/Modal";

import { InsightsUpgradeModal } from "..";

function InsightsDisabledModal({ type, message, onClose, ...props }) {
  switch (type) {
    case "ELIGIBILITY":
      return (
        <InsightsUpgradeModal message={message} onClose={onClose} {...props} />
      );
    case "PERMISSION":
      return (
        <Modal
          data-test="permission-modal"
          size="mini"
          isModalOpen
          onClose={onClose}
        >
          <Modal.Header onClose={onClose}>Permission Denied</Modal.Header>
          <Modal.Body>{message}</Modal.Body>
        </Modal>
      );
    default:
      return null;
  }
}

InsightsDisabledModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  type: PropTypes.string,
  message: PropTypes.string,
};

InsightsDisabledModal.defaultProps = { type: null, message: "" };

export default InsightsDisabledModal;
